<template lang="html">
  <div class="counter">
    {{counter}}
  </div>
</template>

<script>
export default {
  name: 'notificationCounter',
  props: {
    counter: {
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.counter {
  position: absolute;
  top: -8px;
  right: -7px;
  min-width: 15px;
  height: 15px;
  border-radius: 8px;
  padding-left: 2px;
  padding-right: 3px;
  // padding-top: 1px;
  background: $main-color;
  font-size: 10px;
  line-height: 15px;
  text-align: center;
  color: white;
  box-sizing: border-box;
}
</style>
